import { useCallback, useMemo } from 'react';
import { useLocationGroupStore } from '@frontend/scope';
import { createNamespacedWetagHooks } from '@frontend/wetags';
import { DEFAULT_PAYMENTS_NAMESPACE, PaymentsNamespace } from './namespaces';
import type { PaymentsTags } from './tags';

function useCurrentLocationId(): string {
  const locationId = useLocationGroupStore((state) => state.selectedLocationIds[0] || '');
  return locationId;
}

export type UsePaymentsWetagProps = {
  locationId: string | undefined;
  namespace?: PaymentsNamespace;
};
export const usePaymentsWetag = ({ locationId, namespace = DEFAULT_PAYMENTS_NAMESPACE }: UsePaymentsWetagProps) => {
  const getLocationId = useCallback(() => locationId, [locationId]);
  const wetags = useMemo(() => {
    return createNamespacedWetagHooks<PaymentsTags>(namespace, useCurrentLocationId, getLocationId);
  }, [getLocationId]);

  return wetags;
};
